import { render, staticRenderFns } from "./archives.vue?vue&type=template&id=728fe404&scoped=true"
import script from "./archives.vue?vue&type=script&lang=js"
export * from "./archives.vue?vue&type=script&lang=js"
import style0 from "./archives.vue?vue&type=style&index=0&id=728fe404&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728fe404",
  null
  
)

export default component.exports